<template>
  <div class="popup">
    <div class="top">
      <div class="action-icon" v-if="backAction">
        <img :src="require('../assets/back.svg')" v-on:click="backAction">
      </div>
      <div class="action-icon" v-else-if="closeAction">
        <img :src="require('../assets/close.svg')" v-on:click="closeAction">
      </div>

      <div class="text-wrapper">
        <div v-if="title" class="title">{{ title }}</div>
        <div v-else-if="hasTitleSlot" class="title">
          <slot name="title"></slot>
        </div>
        <div v-if="hasContentSlot" class="content">
          <slot name="content"></slot>
        </div>
      </div>

      <div class="buttons-wrapper">
        <riseup-button v-for="(button, key) in buttons" :key="`button-${key}`"
                       :action="button.action"
                       :title="button.title"
                       :subtitle="button.subtitle"
                       :variant="button.variant"
                       :disabled="button.disabled"
                       :size="button.size"
                       :icon="button.icon"
                       :loading="button.loading"/>
      </div>
    </div>

    <template v-if="hasFooterSlot">
      <separator/>
      <div class="footer-padding">
        <slot name="footer"></slot>
      </div>
    </template>
  </div>
</template>

<script>
import RiseupButton from './RiseupButton.vue';
import Separator from './Separator.vue';

export default {
  name: 'Popup',
  components: {
    RiseupButton,
    Separator,
  },
  props: {
    closeAction: {
      type: Function,
      default: null,
      required: false,
    },
    backAction: {
      type: Function,
      required: false,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    buttons: {
      type: Array,
      required: false,
    },
  },
  computed: {
    hasContentSlot() {
      return !!this.$slots.content;
    },
    hasTitleSlot() {
      return !!this.$slots.title;
    },
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../scss/riseup-colors';

  .popup {
    .top {
      padding: 24px;

      .action-icon {
        display: inline-block;
        height: 14px;
        width: 100%;
        text-align: left;
        line-height: 9px;
        cursor: pointer;
      }

      .text-wrapper {
        color: $riseup_black;
        text-align: right;

        .title {
          font-family: SimplerProBold;
          font-size: 22px;
          line-height: 24px;
          margin-bottom: 20px;
        }

        .content {
          font-size: 16px;
        }
      }

      .buttons-wrapper {
        .riseup-button {
          width: 100%;
          margin-top: 16px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    .footer-padding {
      padding: 24px;
    }
  }
</style>
